import React from "react";
import classnames from "classnames";
import styles from "./overviewTable.module.less";
import DataTable from "@/components/DataTable";
import OverviewLayout from "./OverviewLayout";
import ReactResizeDetector from "react-resize-detector";

const Pagination = DataTable.Pagination;

export const DataConvert = (data) => {
  let ret = {
    pageNum: 0,
    list: [],
    pageSize: 0,
    total: 0,
    totalPages: 0,
  };
  if (data) {
    ret = {
      pageNum: data.pageNumber ? data.pageNumber : 0,
      list: data.rows,
      pageSize: data.pageSize ? data.pageSize : 0,
      total: data.total ? data.total : 0,
      totalPages: data.pageTotal ? data.pageTotal : 0,
    };
  }
  return ret;
};

/**
 * 这是个基于boot对antd封装的table再次封装的CRUDLayout组件，
 * 用来解决繁琐的基本操作,将业务逻辑放到调用的组件。
 */
class OverviewTable extends React.PureComponent {
  state = {
    pageInfo: { page: 1, size: 20 },
    tableHeight: 0,
  };
  componentDidMount() {
    const { searchPageSize } = this.props;
    const { pageInfo } = this.state;
    if (searchPageSize) {
      pageInfo.size = searchPageSize;
    }
    this.changeFilters(this.props.initialValue);
  }
  search = (initialValue) => {
    const { filters, pageInfo } = this.state;
    const { onSearch } = this.props;
    const data = { ...filters, ...pageInfo, ...initialValue };
    Object.keys(data).forEach((key) => {
      if (!data[key] || data[key] === "null" || data[key] === "undefined")
        delete data[key];
    });
    onSearch && onSearch(data);
  };
  changePage = ({ pageNum = 1, pageSize = this.state.pageInfo.size } = {}) => {
    this.setState({ pageInfo: { page: pageNum, size: pageSize } }, this.search);
  };
  changeFilters = (filters) => this.setState({ filters }, this.changePage);
  render() {
    const {
      theme,
      columns,
      dataItems,
      toolBarButtonGroup,
      mySelected,
      selectRow,
      rowKey = "id",
      selectedRowKeys,
      rowSelection,
      showNum,
      title,
      selectType,
      unQuery,
    } = this.props;

    const dataTableProps = {
      theme,
      loading: false,
      columns,
      dataItems,
      rowKey,
      showNum,
      selectType,
      rowSelection,
      isScroll: true,
      mySelected,
      selectedRowKeys,
      onChange: this.changePage,
      onSelect: selectRow,
      ...this.props.otherTableProps,
    };
    if (dataItems && dataItems.list && dataItems.list.length > 0) {
      dataTableProps.scroll = { x: "100%", y: 0 };
    }
    let layoutPara = {
      theme,
      columns,
      title,
      unQuery,
      toolBarButtonGroup,
      onSearch: this.changeFilters,
    };
    return (
      <div className={styles.tableMain}>
        <OverviewLayout {...layoutPara}>
          <div className={styles.tableInfo}>
            <ReactResizeDetector handleHeight>
              {({ width, height }) => {
                if (dataTableProps.scroll) {
                  dataTableProps.scroll.y = height - 50;
                }
                return (
                  <div className={styles.tableDiv}>
                    <DataTable className={styles.table} {...dataTableProps} />
                  </div>
                );
              }}
            </ReactResizeDetector>
            {dataItems && dataItems.totalPages > 1 ? (
              <div className={styles.paginationDiv}>
                <Pagination className={styles.pagination} {...dataTableProps} />
              </div>
            ) : (
              ""
            )}
          </div>
        </OverviewLayout>
      </div>
    );
  }
}
export default OverviewTable;
